var indentStyle = {"indentZero":"_0wBqi","indentOne":"wuVpo","indentTwo":"U3nb0","indentThree":"NGtFi","indentFour":"QeCLX","indentFive":"_8fivh","indentSix":"Rlu5E"};

export { indentStyle as i };
//# sourceMappingURL=indentation-08f9ad3a.js.map
